<template>
    <div>
        <div v-if="cgaPatient">
            <div>{{ $t("SELECTED_PATIENT_SHEET") }}: {{ this.cgaPatient.firstName }} {{ this.cgaPatient.lastName }}, <a href="#" @click="stopCga($event)">{{ $t('STOP') }} {{ $t('CGA') }}</a></div>
        </div>
        <div v-if="cgaPatientSheet">
            <div>{{ $t("ACTIVATED_PATIENT_SHEET") }}: <router-link to="/sheets">{{this.cgaPatientSheet.name }}</router-link></div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        cgaPatient() {
            return this.$store.getters.cgaPatient;
        },
        cgaPatientSheet() {
            return this.$store.getters.cgaPatientSheet;
        }
    },
    methods: {
        selectLanguage: function (language) {
            this.$store.dispatch('selectLanguage', language);
        },
        loadSystemLanguages: function () {
            if (!this.cgaStatus) {
                this.$store.dispatch('loadSystemLanguages')
                .then(response => {
                })
                .catch(error => {
                    console.log(error);
                })
            }
        },
        stopCga(event) {
            event.preventDefault();
            this.$store.dispatch("deactivateCga");
            this.$router.push({name: 'patients'});
            this.loadSystemLanguages();
            this.$http.get("/api/doctor/profile")
            .then(response =>
            {
                this.selectLanguage(response.data.language);
            })
            .catch();
        }
    }
}
</script>

<style lang="scss" scoped>
    a {
      color: #428bca !important;  
    }
</style>